define(function (require) {

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var AcWrapper = require('web-agent-utils/AcWrapper');
    var BaseApiService = require('web-agent-utils/BaseApiService');

    lpTag.Skills = function () {

        this.POLLING_TIME_IN_SEC = 600;
        this.SERVICE_NAME = {
            USER_MANAGEMENT: "Skills",
            ACCOUNT_CONFIG: "Skills"
        };

        this.applicationType = "Skills";

        this.logger = WebAgentLogger.getLogger(this.applicationType);

        this._initApi();
    };

    lpTag.Skills.prototype = {

        _initApi: function () {
            if (lpTag.WebAgent.logicController.isAccountConfigUsersEnabled()) {
                this._initAccountConfigApi();
            } else {
                this._initAppServerApi();
            }
        },

        _initAccountConfigApi: function () {
            this.getSkills = function (reqObj) {
                var skillsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getSkillsCollection);

                //if we're running after the first fetch - get the current data so we don't wait for the next fetch
                if (skillsCollection.getFetchState() === skillsCollection.FetchStateEnum.SUCCESS) {
                    reqObj.success({body: skillsCollection.toJSON()});
                }
                else {
                    //bind to changes on the required properties in the data module
                    skillsCollection.listenToOnce(skillsCollection, "fetch:success", function() {
                        reqObj.success({body: skillsCollection.toJSON()});
                    });
                }
            };
        },

        _initAppServerApi: function () {
            this.logger.info('initializing skills API instance for legacy environment', '_initAppServerApi');

            var skillsApiInstance;
            var userManagementApiResource;
            var userManagementUrl;

            userManagementApiResource = agentLEManager.getLEUrlResolverApiResourcesService("UserManagement");

            if (!userManagementApiResource) {
                this.logger.error('failed to create user management API resource, aborting initialization', '_initAppServerApi');
                return;
            }

            if (!userManagementApiResource[this.SERVICE_NAME.USER_MANAGEMENT] ||
                !userManagementApiResource[this.SERVICE_NAME.USER_MANAGEMENT].url) {
                this.logger.error('API resource does not contain the requested service, or API resource service is ' +
                    'missing the URL, aborting initialization', '_initAppServerApi', userManagementApiResource);
                return;
            }

            userManagementUrl = agentLEManager.getLEUrlResolverGetUrl(
                userManagementApiResource[this.SERVICE_NAME.USER_MANAGEMENT].url);

            if (!userManagementUrl) {
                this.logger.error('failed to resolve API resource URL, aborting initialization');
                return;
            }

            skillsApiInstance = BaseApiService.createInstance({
                domainUrl: userManagementUrl,
                postmessagePath: "/postmessage",
                serviceName: this.SERVICE_NAME.USER_MANAGEMENT
            });

            if (!skillsApiInstance) {
                this.logger.error('failed to create user management API instance, aborting initialization', '_initAppServerApi');
                return;
            }

            this.getSkills = function (reqObj) {
                reqObj.callingFunction = 'getSkills';
                reqObj.method = 'GET';
                reqObj.pollingTimeout = 1000 * this.POLLING_TIME_IN_SEC;
                skillsApiInstance.startPolling(reqObj);
            };

            this.stopPolling = function () {
                skillsApiInstance.stopPolling();
            };
        }
    };

    return lpTag.Skills;

});
